function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFocusMap = function SvgIconFocusMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 566 670",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconFocusMap_svg__a",
    x1: 103.38,
    x2: 367.032,
    y1: 643.826,
    y2: 88.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e95634"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f49e48"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M532.78 162.94c-13.39-31-32.3-58.01-56.72-81.03-24.43-23.01-52.97-40.75-85.61-53.2C357.8 16.27 321.99 10.04 283 10.04s-74.81 6.34-107.45 19.02C142.9 41.74 114.36 59.6 89.94 82.61c-24.43 23.02-43.34 49.92-56.72 80.68C19.83 194.06 13.14 228 13.14 265.11c0 36.64 6.69 70.46 20.08 101.46 9.92 22.98 22.88 43.76 38.87 62.35-.28.11-.56.21-.84.32C154.31 530.17 234.6 612.9 266.73 645.2l14.85 14.76 14.85-14.76c30.08-30.24 102.39-104.71 179.66-196.91 24.41-23.01 43.32-50.13 56.7-81.37 13.39-31.23 20.08-65.18 20.08-101.82 0-37.09-6.7-71.16-20.09-102.16m-392.46 38.4c7.75-19.02 18.55-35.69 32.41-50.03 13.85-14.32 30.18-25.37 48.97-33.12 18.78-7.75 39.22-11.63 61.3-11.63 22.07 0 42.39 3.88 60.95 11.63 18.55 7.75 34.88 18.79 48.97 33.12s25.01 31 32.76 50.03 11.63 40.28 11.63 63.77-3.88 44.74-11.63 63.77c-7.75 19.02-18.67 35.7-32.76 50.03s-30.42 25.37-48.97 33.12c-18.56 7.75-38.87 11.63-60.95 11.63-22.09 0-42.52-3.88-61.3-11.63-18.79-7.75-35.12-18.78-48.97-33.12-13.86-14.32-24.66-31-32.41-50.03s-11.63-40.27-11.63-63.77c0-23.49 3.87-44.74 11.63-63.77",
    style: {
      fill: "url(#iconFocusMap_svg__a)"
    }
  }));
};
export default SvgIconFocusMap;